<template>
  <el-container :style="bgStyles" class="auth">
    <el-col :xs="20" :sm="12" :md="12" :lg="8" :xl="6">
      <el-row v-if="course.logo" class="auth-logo">
        <img :src="course.logo" alt="Logo">
      </el-row>
      <el-row class="auth-form">
        <div class="title">Create your account</div>
        <el-input v-model="form.name" placeholder="Your name"/>
        <el-input v-model="form.email" placeholder="Email"/>
        <el-input v-model="form.password" type="password" placeholder="Password"/>
        <el-button type="success" @click="registration">REGISTRATION</el-button>
      </el-row>
      <router-link to="/login" class="not-a-member">
        <img src="/lock-gray.png" alt="lock image">
        already have an account?
      </router-link>
    </el-col>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    loading: false,
    form: {
      name: '',
      email: '',
      password: '',
    },
  }),
  computed: {
    ...mapGetters(['course']),
    bgStyles() {
      const bg = this.course['auth-background'];

      if (bg.includes('http')) {
        return { 'background-image': `url("${bg}")` };
      }

      return {};
    },
  },
  methods: {
    registration() {
      this.loading = true;
      window.http.post('/registration', this.form)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$notify({
              type: 'success',
              text: 'Registration successful',
              duration: 2000,
            });
            this.$router.push('/login');
          } else {
            this.$notify({
              type: 'error',
              text: response.data.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            type: 'error',
            text: error.data.message,
            duration: 2000,
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
